export default __webpack_public_path__ + "static/media/clear_day.d298591d.svg";